module.exports = __webpack_public_path__ + "static/media/intro_bg.4f099ca8.mp4";